import React, { useState } from "react";

export const ChatButton = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Verifica si `props.data` está definido
  if (!props.data) {
    return <p>Loading...</p>;
  }

  return (
    <>
      {/* Botón flotante de chat */}
      <button style={styles.chatButton} onClick={handleToggleModal}>
        {props.data.TextButton || "Chat"}
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h2 style={styles.modalTitle}>{props.data.title}</h2>
            <form style={styles.form}>
              <label style={styles.label}>{props.data.labelName}</label>
              <input
                type="text"
                placeholder={props.data.placeholderName}
                style={styles.input}
              />

              <label style={styles.label}>{props.data.labelEmail}</label>
              <input
                type="email"
                placeholder={props.data.placeholderEmail}
                style={styles.input}
              />

              <label style={styles.label}>{props.data.labelMessage}</label>
              <textarea
                placeholder={props.data.placeholderMessage}
                style={styles.textarea}
              ></textarea>

              <label style={styles.label}>{props.data.getContact}</label>
              <h3 style={{ margin: "10px 20px" }}>
                <img
                  src="/img/iconsup.png"
                  alt=""
                  style={{ width: "25px", marginRight: "15px" }}
                />
                <a
                  href="tel:+4740062510"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  +47 400 62 510
                </a>
              </h3>

              <button type="submit" style={styles.submitButton}>
                {props.data.buttonSend}
              </button>
              <button
                type="button"
                style={styles.closeButton}
                onClick={handleToggleModal}
              >
                {props.data.buttonClose}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

// 🎨 Estilos en línea
const styles = {
  chatButton: {
    border: "none",
    padding: "8px 10px",
    color: "#fff",
    position: "fixed",
    bottom: "20px",
    right: "3px",
    width: "130px",
    height: "auto",
    backgroundColor: "rgba(0,0,0, 0.5)",
    borderRadius: "15px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    zIndex: 1000,
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1001,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "350px",
    textAlign: "center",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  },
  modalTitle: {
    fontSize: "22px",
    marginBottom: "10px",
    color: "#0A3A2C",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    textAlign: "left",
    fontSize: "14px",
    marginBottom: "5px",
    color: "#333",
  },
  input: {
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  textarea: {
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "14px",
    height: "80px",
    resize: "none",
  },
  submitButton: {
    backgroundColor: "#0A3A2C",
    color: "#fff",
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    marginBottom: "10px",
  },
  closeButton: {
    backgroundColor: "#ccc",
    color: "#333",
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
  },
};
